module.exports = __webpack_public_path__ + "img/image02.e37b4062.jpg";